import React from "react"

import {
  Blur,
  ButtonWrapper,
  CancelButton,
  CancelOperationButton,
  Container,
  HeaderWrapper,
  Item,
  StyledErrorMessage
} from "./Popup.styled"

import PrimaryButton from "./Buttons/PrimaryButton"

import { ReactComponent as ArrowRight } from "images/icons/arrow-right.svg"

type Props = {
  children?: React.ReactNode
  type?: "delete" | "default"
  title: string | React.ReactNode
  subtitle?: string
  item?: {
    itemId: string | undefined
    itemName: string
  }
  buttonText?: string
  cancelButtonText?: string
  loading?: boolean
  handleOkClick?: React.MouseEventHandler
  handleCloseClick: React.MouseEventHandler
  blurBackgroundColor?: boolean
  errorMessage?: string
  hideOkButton?: boolean
  disableOkButton?: boolean
  maxWidth?: string
  cancelOperation?: () => void
  cancelOperationLoading?: boolean
  backgroundColor?: string
}

const Popup = ({
  children,
  type = "default",
  title,
  subtitle,
  item,
  loading,
  blurBackgroundColor = true,
  buttonText,
  cancelButtonText,
  handleOkClick,
  handleCloseClick,
  errorMessage,
  hideOkButton,
  disableOkButton,
  maxWidth,
  cancelOperation,
  cancelOperationLoading,
  backgroundColor
}: Props) => (
  <div>
    <Blur onClick={handleCloseClick} $blurBackgroundColor={blurBackgroundColor} />
    <Container $maxWidth={maxWidth ?? "55rem"} $backgroundColor={backgroundColor}>
      {cancelOperation && (
        <HeaderWrapper>
          <CancelOperationButton
            handleClick={() => cancelOperation()}
            loading={cancelOperationLoading}
          >
            Cancel update
          </CancelOperationButton>
        </HeaderWrapper>
      )}
      <h2>{title}</h2>
      {subtitle && <p>{subtitle}</p>}
      {item && (
        <Item>
          <li>
            <h4>
              <ArrowRight />
              {item.itemName}
            </h4>
            {item?.itemId && <span>{item.itemId}</span>}
          </li>
        </Item>
      )}
      {errorMessage && errorMessage !== "" && <StyledErrorMessage message={errorMessage} />}
      {children}
      {
        <>
          <ButtonWrapper>
            <CancelButton handleClick={handleCloseClick}>
              {cancelButtonText ?? "Cancel"}
            </CancelButton>
            {!hideOkButton && (
              <PrimaryButton
                loading={loading}
                handleClick={handleOkClick}
                mode={type}
                disabled={disableOkButton}
              >
                {buttonText ?? "Yes, delete"}
              </PrimaryButton>
            )}
          </ButtonWrapper>
        </>
      }
    </Container>
  </div>
)

export default Popup
